import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import { DEDICATED_AUTH0_FLOW } from "@white-label-configuration/constants";
import { jwtDecode } from 'jwt-decode';
import { datadogRum } from "@datadog/browser-rum";
/**
 * Checks the current route's auth0flow matches with the given routeName for the dedicated wl flow.
 * @param route Vue Router
 * @param routeName (Optional) route name to check auth0 flow against, defaults to DEDICATED_AUTH0_FLOW
 * @returns True or false if current route matches against name
 */
export var isDedicatedFlow = function isDedicatedFlow(route) {
  var _ref;
  var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEDICATED_AUTH0_FLOW;
  return ((_ref = Array.isArray(route === null || route === void 0 ? void 0 : route.meta) ? route.meta[0] : route === null || route === void 0 ? void 0 : route.meta) === null || _ref === void 0 ? void 0 : _ref.auth0Flow) === routeName;
};
export var getUrlParam = function getUrlParam(route, param) {
  var _route$query, _route$query$param;
  return route === null || route === void 0 ? void 0 : (_route$query = route.query) === null || _route$query === void 0 ? void 0 : (_route$query$param = _route$query[param]) === null || _route$query$param === void 0 ? void 0 : _route$query$param.toString();
};

/**
 * Decodes a JWT token
 * @param token The JWT token to decode
 * @returns An object with the decoded token or an empty object if decoding fails
 */
export var decodeToken = function decodeToken(token) {
  try {
    return jwtDecode(token.replace('Bearer ', ''));
  } catch (error) {
    datadogRum.addError(new Error('Auth decodeToken:', {
      cause: error
    }), {
      file: 'white-label-helper > dedicated-flow > decodeToken()',
      token: token || ''
    });
    return {};
  }
};

/**
 * Returns the permissions property from the decoded token
 * @param token The JWT token to decode
 * @returns An array of permissions or an empty array if decoding fails
 */
export var getUserPermissions = function getUserPermissions(token) {
  var decodedToken = decodeToken(token);
  return (decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken['permissions']) || [];
};

/**
 * Redirects the customer service agent back to the extranet
 * @param orderReference - Order reference id
 */
export function redirectToExtranet(orderReference) {
  var nuxtApp = useNuxtApp();
  var redirectUrl = nuxtApp['$cookies'].get("auth0.".concat(nuxtApp['$config']['AUTH0_PARTNER_CLIENT_ID'], ".returnUrl"));
  if (isDedicatedFlow(nuxtApp['$route'])) {
    window.location.assign("".concat(redirectUrl, "?showOrdersList=true&orderId=").concat(orderReference));
  }
}